<section class="bg-(--color-main) pt-10 pb-15">
  <div class="cta-body text-center">
  <h3>لم تجد المشروع المناسب؟</h3>
  <p>تواصل معنا وسنساعدك في اختيار الفرصة التعاقدية الأنسب لأهدافك</p>
  </div>

  <div class="flex justify-center mt-10 cursor-pointer">
        <button routerLink="/contact-us" class="bg-(--color-secondary) text-(--color-main) px-25 h-12 rounded-md font-semibold inline-flex items-center gap-2 cursor-pointer">
        تواصل معنا الأن
        </button>
      </div>
</section>
